import React, { createContext, useContext, useEffect, useState } from 'react';

const GlobalContext = createContext();

export const useGlobalContext = () => useContext(GlobalContext);

export const GlobalProvider = ({ children }) => {
    const [isMobile, setIsMobile] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [serviceProviderDetailsActiveTab, setServiceProviderDetailsActiveTab] = useState('services');
    const [serviceProviderActiveTab, setServiceProviderActiveTab] = useState('onboarded');
    const [onboardedPage, setOnboardedPage] = useState(0);


    useEffect(() => {
        if (window.innerWidth < 420) {
            setIsMobile(true);
        }
    }, []);
    return (
        <GlobalContext.Provider value={{
            sidebarOpen,
            setSidebarOpen,
            serviceProviderActiveTab,
            setServiceProviderActiveTab,
            serviceProviderDetailsActiveTab,
            setServiceProviderDetailsActiveTab,
            onboardedPage,
            setOnboardedPage,
            isMobile,
        }}>
            {children}
        </GlobalContext.Provider>
    );
};



